import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import {
  COUNTDOWN_FEATURE_KEY,
  initialState as countDownInitialState,
  countDownReducer
} from './+state/count-down.reducer';
import { CountDownFacade } from './+state/count-down.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(COUNTDOWN_FEATURE_KEY, countDownReducer)
  ],
  providers: [CountDownFacade]
})
export class CommonCountDownDataAccessCountDownModule {}
